import type { CreateSignatureRequestsResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils/logging';

import { zodCreateSignatureRequestsResponseSchema } from './validations';

/**
 * Creates signature requests for a delivery note.
 *
 * @param deliveryNoteId - The delivery note ID to request signatures for.
 * @param recipientIds - The recipient user IDs.
 * @returns A promise that resolves with the API response.
 */
export const createSignatureRequests = async (
  deliveryNoteIds: UUID[],
  recipientIds: UUID[],
): Promise<CreateSignatureRequestsResponse> => {
  const response = await vestigasApi
    .post(ENDPOINT.DELIVERY_NOTE.CREATE_SIGNATURE_REQUESTS(), {
      json: {
        deliveryNoteIds,
        recipientIds,
      },
    })
    .json<CreateSignatureRequestsResponse>();

  const validatedResponse =
    zodCreateSignatureRequestsResponseSchema.safeParse(response);

  if (validatedResponse?.error?.issues?.length) {
    log.error({
      message: 'Create signature requests API response has validation errors',
      error: {
        errors: validatedResponse?.error?.issues,
        errorMessage: validatedResponse?.error?.message,
        response,
      },
    });
  }

  return response;
};
